import React, { useEffect, useState } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";
import {
  InfoWindow,
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon,
  StreetViewPanorama,
} from "react-google-maps";

import { useAlert } from "../components/Alert";

const GET_FORECLOSURE = gql`
  query foreclosure($obj_no: Int!) {
    foreclosure(obj_no: $obj_no) {
      obj_str
      obj_share
      obj_caseno
      obj_another
      obj_date_hi
      obj_date_ymd
      obj_type
      obj_patterns
      obj_city
      obj_area
      obj_section
      obj_section_s
      obj_landno
      obj_address
      obj_margin
      obj_price
      obj_debtor
      obj_build_floor
      obj_land_floor
      obj_total_floor
    }
  }
`;

export default function SimpleInfo() {
  const mobile = new URLSearchParams(useLocation().search);
  const { id } = useParams();
  const Alert = useAlert();
  const [lat, setLat] = useState();
  const [lng, setLng] = useState();
  const [coordinates, setCoordinates] = useState([]);

  const useStyles = makeStyles((theme) => ({
    formBox: {
      width: "80%",
      maxHeight: "1754px",
      minHeight: "100vh",
      margin: "0 auto",
      //   paddingLeft: "200px",
    },

    // table
    table: {
      width: "100%",
      minWidth: "900px",
      "& th": {
        padding: "5px 3px",
        border: "1px solid grey",
        whiteSpace: "pre-wrap",
      },
      "& td": {
        padding: "5px 3px",
        border: "1px solid grey",
        whiteSpace: "pre-wrap",
      },
    },
  }));
  const classes = useStyles();
  const [getForeclosure, { data, loading }] = useLazyQuery(GET_FORECLOSURE, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosure }) {
      let latlng = [];
      fetch(
        `https://twland.ronny.tw/index/search?lands[]=${
          foreclosure.obj_city +
          "," +
          foreclosure.obj_section +
          "段" +
          "," +
          foreclosure.obj_landno
        }`
      )
        .then((res) => res.json())
        .then((result) => {
          result.features[0].geometry.coordinates[0].forEach((item) =>
            item.forEach((item2) =>
              latlng.push({ lat: item2[1], lng: item2[0] })
            )
          );
          setLat(result.features[0].properties.ycenter);
          setLng(result.features[0].properties.xcenter);
          setCoordinates(latlng);
        })
        .catch((e) => {
          fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${
              foreclosure.obj_type === "H"
                ? foreclosure.obj_city +
                  foreclosure.obj_area +
                  foreclosure.obj_address
                : foreclosure.obj_city +
                  foreclosure.obj_area +
                  foreclosure.obj_section +
                  "段" +
                  foreclosure.obj_section_s +
                  (foreclosure.obj_section_s ? "小段" : "") +
                  foreclosure.obj_landno +
                  (foreclosure.obj_landno ? "號" : "")
            }&key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE`
          )
            .then((res) => res.json())
            .then(({ results, status }) => {
              if (status === "OK") {
                setLng(results[0].geometry.location.lng);
                setLat(results[0].geometry.location.lat);
              }
            });
        });
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });

  const StreetViewPanormaWithAnOverlayView = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        defaultZoom={15}
        defaultCenter={{
          lat: lat,
          lng: lng,
        }}
      >
        <StreetViewPanorama
          defaultPosition={{
            lat: lat,
            lng: lng,
          }}
          visible
        ></StreetViewPanorama>
      </GoogleMap>
    ))
  );
  const options = {
    fillColor: "#f44336",
    fillOpacity: 0.2,
    strokeColor: "#f44336",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 999,
  };

  const onLoad = (polygon) => {
    console.log("polygon: ", polygon);
  };

  const MapWithAMarker = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        defaultZoom={18}
        defaultCenter={{
          lat: lat,
          lng: lng,
        }}
        streetView
      >
        <Marker
          position={{
            lat: lat,
            lng: lng,
          }}
        >
          <InfoWindow>
            <Grid container direction="column" style={{ overflow: "hidden" }}>
              <Grid item>
                <Typography style={{ color: "red" }}>
                  {data.foreclosure.obj_type === "H"
                    ? data.foreclosure.obj_city +
                      data.foreclosure.obj_area +
                      data.foreclosure.obj_address
                    : data.foreclosure.obj_city +
                      data.foreclosure.obj_area +
                      data.foreclosure.obj_section +
                      "段" +
                      data.foreclosure.obj_section_s +
                      (data.foreclosure.obj_section_s ? "小段" : "") +
                      data.foreclosure.obj_landno +
                      (data.foreclosure.obj_landno ? "地號" : "")}
                </Typography>
              </Grid>
              <Grid item>
                <img
                  style={{ maxHeight: "50px", width: "100%" }}
                  src={require("../images/mapMark.jpg").default}
                />
              </Grid>
            </Grid>
          </InfoWindow>
        </Marker>
        {coordinates.length !== 0 && (
          <Polygon onLoad={onLoad} path={coordinates} options={options} />
        )}
      </GoogleMap>
    ))
  );

  useEffect(() => {
    if (id) {
      getForeclosure({
        variables: {
          obj_no: Number(id),
        },
      });
    }
  }, [id]);
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Box className={classes.formBox}>
        {/* Title */}
        <Box mt={10}>
          <Grid container>{`聯絡電話：${mobile.get("mobile")}`}</Grid>
          <TableContainer component={Paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell align={"center"}>類別</TableCell>
                  <TableCell align={"center"}>地址</TableCell>
                  <TableCell align={"center"}>{`建坪\n地坪`}</TableCell>
                  <TableCell align={"center"}>{`建坪／萬\n地坪／萬`}</TableCell>
                  <TableCell align={"center"}>{`拍賣底價\n保證金`}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align={"center"}>
                    {(() => {
                      switch (data?.foreclosure.obj_type) {
                        case "L":
                          return data?.foreclosure.obj_patterns !== ""
                            ? data?.foreclosure.obj_patterns
                            : "土地";
                        case "H":
                          return data?.foreclosure.obj_patterns !== ""
                            ? data?.foreclosure.obj_patterns
                            : "建物";
                        default:
                          return "";
                      }
                    })()}
                  </TableCell>
                  <TableCell align={"center"}>
                    {data?.foreclosure.obj_type === "H"
                      ? data?.foreclosure.obj_city +
                        data?.foreclosure.obj_area +
                        data?.foreclosure.obj_address
                      : data?.foreclosure.obj_city +
                        data?.foreclosure.obj_area +
                        data?.foreclosure.obj_section +
                        "段" +
                        data?.foreclosure.obj_section_s +
                        (data?.foreclosure.obj_section_s ? "小段" : "") +
                        data?.foreclosure.obj_landno +
                        (data?.foreclosure.obj_landno ? "地號" : "")}
                  </TableCell>
                  <TableCell align={"center"}>
                    {data?.foreclosure.obj_total_floor +
                      "\n" +
                      data?.foreclosure.obj_land_floor}
                  </TableCell>
                  <TableCell align={"center"}>
                    {data?.foreclosure.obj_total_floor === 0
                      ? 0 + "\n"
                      : (
                          data?.foreclosure.obj_price /
                          data?.foreclosure.obj_total_floor
                        ).toFixed(2) +
                        "萬" +
                        "\n"}
                    {data?.foreclosure.obj_land_floor === 0
                      ? 0
                      : (
                          data?.foreclosure.obj_price /
                          data?.foreclosure.obj_land_floor
                        ).toFixed(2) + "萬"}
                  </TableCell>
                  <TableCell align={"center"}>
                    {data?.foreclosure.obj_price +
                      "萬" +
                      "\n" +
                      (data?.foreclosure.obj_margin / 10000).toFixed(2) +
                      "萬"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE&v=3.exp&libraries=geometry,drawing"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </Grid>
            <Grid item sm={6}>
              <StreetViewPanormaWithAnOverlayView
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAmN8gx3xtVVI4kMAvjAruO9yUgPenMPqE&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `400px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }
}
